import CssBaseline from '@material-ui/core/CssBaseline'
import React, { lazy, useEffect } from 'react'
import AllProviders from '../AllProviders'
import GlobalStyle from '../GlobalStyle'
import MainRouter from '../MainRouter'
import HTMLTagUpdater from 'components/HTMLTagUpdater'
import { LoadSentryClient } from 'context/ErrorReporting'

const LazyCookies = lazy(() =>
  import('./DelayedModules/DelayedModules').then((r) => ({
    default: r.CookiesConsent,
  }))
)

function App(): React.ReactElement {
  useEffect(() => {
    LoadSentryClient()
  }, [])
  return (
    <AllProviders>
      <CssBaseline />
      <GlobalStyle />
      <MainRouter />
      <LazyCookies />
      <HTMLTagUpdater />
    </AllProviders>
  )
}

export default App
